<div class="headerFlexW p-0">
  <div class="content-block">
    <a class="bread-crumbs" routerLink="../../">Usuarios</a>
    <span class="bread-crumbs mx-2">|</span>
    <span class="bread-crumbs">Detalle</span>
    <h2 class="">Detalle de Usuario</h2>
  </div>
</div>
<!-- CONTENT -->
<div class="content-block">
  <div class="dx-card">
    <dx-tab-panel #tabPanel
        [height]="'auto'"
        [dataSource]="tabs"
        [selectedIndex]="tabIndex"
        [loop]="false"
        [animationEnabled]="false"
        [swipeEnabled]="true"        
        (onSelectionChanged)="onTabChange($event, tabPanel.selectedIndex)">
      
        <!-- Tab Title-->
      <div *dxTemplate="let tab of 'title'">
        <span>{{tab.label}}</span>
      </div>
      
      <!-- Tab Content -->
      <div *dxTemplate="let tab of 'item'" class="p-3">
        <ng-container *ngIf="tabIndex == 0">
          <div class="d-md-flex flex-nowrap flex-space-between">
            <div class="px-4">
              <i class="far fa-id-card text-success" style="font-size: 100px"></i>
            </div>
            <!-- User -->
            <ng-container *ngIf="user">
              <div class="w-100">
                <ul class="list-no-style p-0">
                  <li>
                    <strong> ID: </strong>
                    <span>{{ user.id }}</span>
                  </li>
                  <li>
                    <strong> Nombre: </strong> 
                    <span>{{ user.name }} {{ user.middleName }} {{ user.lastName }} {{ user.seconLastName }}</span>
                  </li>
                  <li>
                    <strong> Email: </strong> 
                    <span>{{ user.email }}</span>
                  </li>
                  <li>
                    <strong> Teléfono: </strong> 
                    <span>{{ user.phone }}</span>
                  </li>
                  <li>
                    <strong> RFC: </strong> 
                    <span>{{ user.rfc }}</span>
                  </li>
                  <li>
                    <strong> Sexo: </strong> 
                    <span>{{ user.gender }}</span>
                  </li>
                  <li>
                    <strong> Fecha Nacimiento: </strong> 
                    <span>{{ user.birthDate }}</span>
                  </li>
                </ul>
              </div>

              <div class="w-100">
                <ul class="list-no-style p-0">
                  <li>
                    <strong> Empresa: </strong>
                    <span>-</span>
                  </li>
                  <li>
                    <strong> No. Empleado: </strong>
                    <span>-</span>
                  </li>
                  <li>
                    <strong> Activo: </strong>
                    <span>-</span>
                  </li>
                  <li>
                    <strong> Fecha Registro: </strong>
                    <span>-</span>
                  </li>
                  <li>
                    <strong> UserAPP: </strong>
                    <span>{{ user.appUser }}</span>
                  </li>
                  <li>
                    <strong> EmailVerified: </strong>
                    <span>{{ user.verified }}</span>
                  </li>
                </ul>
              </div>

              <div class="w-100" *ngIf="user.program[0].card">
                <ul class="list-no-style p-0">
                  <li>
                    <strong> Tarjeta: </strong>
                    <span>{{ card.cardNumberCacao }}</span>
                  </li>
                  <li>
                    <strong> Estatus: </strong>
                    <span>{{ card.status }}</span>
                  </li>
                  <li>
                    <strong> Fecha Activación: </strong>
                    <span>{{ card.dateCardAssigned | date:'yyyy-MM-dd hh:mm a' }}</span>
                  </li>
                  <li>
                    <strong> Saldo: </strong>
                    <span>{{ card.balance | currency }}</span>
                  </li>
                  <li>
                    <strong> Estatus NIP: </strong>
                    <span>{{ card.statusNIP }}</span>
                  </li>
                  <li>
                    <strong> NIP: </strong>
                    <span>{{ card.NIP }}</span>
                  </li>
                </ul>
              </div>
            </ng-container>
          </div>

            <div>
              <div class="mb-3">
                <dx-button text="Actualizar Email" type="default" (onClick)="openClosePopup('update_email',true)"></dx-button>
              </div>
              <div>
                <dx-button text="Enviar Email Bienvenida" type="default" (onClick)="sendEmailBienvenida()"></dx-button>
              </div>
            </div>
        </ng-container>


        <ng-container *ngIf="tabIndex != 0">
          <ng-container [ngSwitch]="tabIndex">
            
            <ag-container *ngSwitchCase="1">
              <ng-container *ngIf="!user.program[0].card">
                <div>No se ha asignado una tarjeta al usuario</div>
              </ng-container>
              <ng-container *ngIf="user.program[0].card">
                <app-dispersion-user [user]="user" [card]="user.program[0].card"></app-dispersion-user>
              </ng-container>
            </ag-container>

            <ng-container *ngSwitchCase="2">
              <ng-container *ngIf="!user.program[0].card">
                <div>No se ha asignado una tarjeta al usuario</div>
              </ng-container>
              <ng-container *ngIf="user.program[0].card">
                <app-movements-table [card]="user.program[0].card"></app-movements-table>
              </ng-container>
            </ng-container>

          </ng-container>
          
        </ng-container>
      </div>

    </dx-tab-panel>
    <div class="flex flex-nowrap flex-space-between align-items-start datagrid-detailsW">
      

    </div>
  </div>
</div>


<!-- Popup Actualizar Email -->
<app-user-popup-update-email [user]="user" [visible]="popup.updateEmail" (onClose)="onClosePopup($event, 'update_email')"></app-user-popup-update-email>